import { ETheme as s, EScene as n } from "../../common/type.mjs";
import h from "react";
class m {
  constructor(e, t) {
    this._theme = e, this._scene = t;
  }
  get theme() {
    return this._theme;
  }
  setTheme(e) {
    this._theme = e;
  }
  get scene() {
    return this._scene;
  }
  setScene(e) {
    this._scene = e;
  }
}
const i = h.createContext(new m(s.LIGHT, n.REOLINK));
export {
  i as ThemeConfigContext,
  i as default
};
//# sourceMappingURL=globalTheme.mjs.map
